import { render, staticRenderFns } from "./PrimerViewer.vue?vue&type=template&id=0806e63a&functional=true&"
import script from "./PrimerViewer.vue?vue&type=script&lang=js&"
export * from "./PrimerViewer.vue?vue&type=script&lang=js&"
import style0 from "./PrimerViewer.vue?vue&type=style&index=0&id=0806e63a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports